import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";
import { FEATURE_ID, ROUTE } from "../../Common/constant";
import "../../assets/css/custom.css";
import Logo from "../../assets/images/logo.png";

export default function Header({ variant }) {
    const { pathname } = useLocation()
    const isAtHome = pathname === ROUTE.BASE_URL

    const getDesktop = () => {
        const screenWidth = window.innerWidth
        if (screenWidth < 991) return false
        return true
    }

    const [isSticky, setIsSticky] = useState(false);
    const [mobileToggle, setMobileToggle] = useState(false);
    const [isDesktop, setIsDesktop] = useState(getDesktop())

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 2) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        });

        const onResize = () => setIsDesktop(getDesktop())
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <header id={FEATURE_ID.HOME} className={`${isDesktop ? "main-header" : "main-header-mobile"} header__style__one ${variant ? variant : ""} header__sticky ${isSticky ? "fixed-header" : ""}`}>
            <div className="header-lower">
                <div className="auto-container">
                    <div className="outer-box">
                        <div className="logo-box">
                            <figure className="logo">
                                {isAtHome ?
                                    <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}><img src={Logo} alt="" className="logo_img" /></LinkScroll>
                                    :
                                    <Link to={ROUTE.BASE_URL}><img src={Logo} alt="" className="logo_img" /></Link>
                                }
                            </figure>
                        </div>
                        <div className="menu-area clearfix">
                            <div className={mobileToggle ? "mobile-menu-visible" : "mobile-menus"} >
                                <div className="mobile-nav-toggler" onClick={() => setMobileToggle(!mobileToggle)}>
                                    <i className="icon-bar"></i>
                                    <i className="icon-bar"></i>
                                    <i className="icon-bar"></i>
                                </div>
                                <div className="mobile-menu">
                                    <div className="menu-backdrop"></div>
                                    <div className="close-btn" onClick={() => setMobileToggle(!mobileToggle)}><i className="icon-fa-times"></i></div>

                                    <nav className="menu-box">
                                        <div className="nav-logo">
                                            {isAtHome ?
                                                <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}><img src={Logo} alt="" className="logo_img" /></LinkScroll>
                                                :
                                                <Link to={ROUTE.BASE_URL}><img src={Logo} alt="" className="logo_img" /></Link>
                                            }
                                        </div>
                                        <div className="menu-outer">
                                            <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                                {isAtHome ?
                                                    <ul className="navigation clearfix home-menu">
                                                        <li style={{ cursor: "pointer" }}>
                                                            <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Home</LinkScroll>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <LinkScroll to={FEATURE_ID.ABOUT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>About</LinkScroll>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.PRODUCTS.BASE_URL}>Products</Link>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <LinkScroll to={FEATURE_ID.SERVICE} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Services</LinkScroll>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <LinkScroll to={FEATURE_ID.INDUSTRY} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Industries</LinkScroll>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <LinkScroll to={FEATURE_ID.PARTNER_CLIENT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Partner & Client</LinkScroll>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.NEWS_ARTICLES}>News & Articles</Link>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.CONTACT_US}>Contact</Link>
                                                        </li>
                                                    </ul>
                                                    :
                                                    <ul className="navigation clearfix home-menu">
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.BASE_URL}>Home</Link>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.PRODUCTS.BASE_URL} className={pathname.includes(ROUTE.PRODUCTS.BASE_URL) ? "active" : ""}>Products</Link>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.NEWS_ARTICLES} className={pathname === ROUTE.NEWS_ARTICLES ? "active" : ""}>News & Articles</Link>
                                                        </li>
                                                        <li style={{ cursor: "pointer" }}>
                                                            <Link to={ROUTE.CONTACT_US} className={pathname === ROUTE.CONTACT_US ? "active" : ""}>Contact</Link>
                                                        </li>
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                            <nav className="main-menu navbar-expand-md navbar-light">
                                <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                    {isAtHome ?
                                        <ul className="navigation clearfix home-menu">
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Home</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.ABOUT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>About</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.PRODUCTS.BASE_URL}>Products</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.SERVICE} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Services</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.INDUSTRY} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Industries</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.PARTNER_CLIENT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Partner & Client</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.NEWS_ARTICLES}>News & Articles</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.CONTACT_US}>Contact</Link>
                                            </li>
                                        </ul>
                                        :
                                        <ul className="navigation clearfix home-menu">
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.BASE_URL}>Home</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.PRODUCTS.BASE_URL} className={pathname.includes(ROUTE.PRODUCTS.BASE_URL) ? "active" : ""}>Products</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.NEWS_ARTICLES} className={pathname === ROUTE.NEWS_ARTICLES ? "active" : ""}>News & Articles</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.CONTACT_US} className={pathname === ROUTE.CONTACT_US ? "active" : ""}>Contact</Link>
                                            </li>
                                        </ul>
                                    }
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sticky-header">
                <div className="auto-container">
                    <div className="outer-box">
                        <div className="logo-box">
                            {isAtHome ?
                                <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}><img src={Logo} alt="" className="logo_img" /></LinkScroll>
                                :
                                <Link to={ROUTE.BASE_URL}><img src={Logo} alt="" className="logo_img" /></Link>
                            }
                        </div>
                        <div className="menu-area clearfix">
                            <nav className="main-menu clearfix">
                                <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                    {isAtHome ?
                                        <ul className="navigation clearfix home-menu">
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Home</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.ABOUT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>About</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.PRODUCTS.BASE_URL}>Products</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.SERVICE} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Services</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.INDUSTRY} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Industries</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <LinkScroll to={FEATURE_ID.PARTNER_CLIENT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }} onClick={() => setMobileToggle(false)}>Partner & Client</LinkScroll>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.NEWS_ARTICLES}>News & Articles</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.CONTACT_US}>Contact</Link>
                                            </li>
                                        </ul>
                                        :
                                        <ul className="navigation clearfix home-menu">
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.BASE_URL}>Home</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.PRODUCTS.BASE_URL} className={pathname.includes(ROUTE.PRODUCTS.BASE_URL) ? "active" : ""}>Products</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.NEWS_ARTICLES} className={pathname === ROUTE.NEWS_ARTICLES ? "active" : ""}>News & Articles</Link>
                                            </li>
                                            <li style={{ cursor: "pointer" }}>
                                                <Link to={ROUTE.CONTACT_US} className={pathname === ROUTE.CONTACT_US ? "active" : ""}>Contact</Link>
                                            </li>
                                        </ul>
                                    }
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
